<template>
    <span class="comment-contated-by" :title="$enum.CommentContactedBy.translate($props.contactedBy)">
        <AtSymbolIcon v-if="$props.contactedBy === $enum.CommentContactedBy.EMAIL" />
        <EnvelopeIcon v-else-if="$props.contactedBy === $enum.CommentContactedBy.MAIL" />
        <PhoneIcon v-else-if="$props.contactedBy === $enum.CommentContactedBy.PHONE" />
        <PencilSquareIcon v-else-if="$props.contactedBy === $enum.CommentContactedBy.REVIEW" />
        <AcademicCapIcon v-else-if="$props.contactedBy === $enum.CommentContactedBy.MODULE_END" />
        <NewspaperIcon v-else-if="$props.contactedBy === $enum.CommentContactedBy.MARKETING" />
        <ClipboardIcon v-else-if="$props.contactedBy === $enum.CommentContactedBy.INTERNE" />
    </span>
</template>

<script lang="ts">
import { AtSymbolIcon, EnvelopeIcon, PhoneIcon, PencilSquareIcon, AcademicCapIcon, NewspaperIcon, ClipboardIcon } from '@heroicons/vue/24/outline'

import { type CommentContactedBy } from '~/api/myedvenn/comment';

export default defineComponent({
    props: {
        contactedBy: Number as PropType<CommentContactedBy>
    },
    components: { AtSymbolIcon, EnvelopeIcon, PhoneIcon, PencilSquareIcon, AcademicCapIcon, NewspaperIcon, ClipboardIcon }
})
</script>

<style lang="postcss">
.comment-contated-by {
    @apply w-4;
}
</style>